import { useState } from 'react';

const useReviewComments = () => {
  const [comments, setComments] = useState({});
  const [reviewComments, setReviewComments] = useState({});
  const [entityComments, setEntityComments] = useState([]);

  return {
    comments,
    setComments,
    reviewComments,
    setReviewComments,
    entityComments,
    setEntityComments,
  };
};

export default useReviewComments;
